import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getvendor_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "vendorevaluation", ...action.payload }),
		);
		yield put({
			type: types.GET_VENDOR_EVALUATION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_VENDOR_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* getvendor_evaluationWatcherSaga() {
	yield takeLatest(
		types.GET_VENDOR_EVALUATION_START,
		getvendor_evaluationHandlerSaga,
	);
}

//create

//delete

function* deletevendor_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("vendorevaluation", action.payload),
		);
		yield put({
			type: types.DELETE_VENDOR_EVALUATION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_VENDOR_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* deletevendor_evaluationWatcherSaga() {
	yield takeLatest(
		types.DELETE_VENDOR_EVALUATION_START,
		deletevendor_evaluationHandlerSaga,
	);
}

//update
